export const paragraphText = {
  HEADER_TEXT_OFFER: "Offer Accepted",
  HEADER_TEXT_CANCELLATION: "Sale Cancellation Accepted",
  LINE_TWO:
    "Any agreed credit amount will be paid into your nominated bank account in accordance with your agreed terms.",
};
